import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectEndHours = createFeatureSelector<any>('end-hours');

export const selectEndHoursState = createSelector(
    selectEndHours,
    (state: any) => state,
);
